export default "__VITE_ASSET__da6ade4f__"